import React, { createContext, useState, useEffect } from 'react';

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const [socketData, setSocketData] = useState(null); // Store the latest socket message data
  const provider = localStorage.getItem("provider");

  useEffect(() => {
    // Connect to the WebSocket server

    const socket = new WebSocket( 
      provider === "Azure"
        ? 'wss://drdashboard.4blabs.com/azure'
        : provider === "AWS" ? 'wss://drdashboard.4blabs.com/aws' : `wss://drdashboard.4blabs.com/gcp`
    );   
    
    socket.onopen = () => {
      console.log('WebSocket connection established');
    };           

    socket.onmessage = (event) => {
      const [updatedData] = JSON.parse(event.data); // Assuming the message is in JSON format
      setSocketData(updatedData); // Update the state with the new WebSocket message
    };

    socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    socket.onclose = () => {
      console.log('WebSocket connection closed');
    };

    // Clean up the socket connection when the component unmounts
    return () => {
      socket.close();
    };
    // eslint-disable-next-line 
  }, []);

    // Function to clear socket data
    const clearSocketData = () => {
      setSocketData(null);
    };

  return (
    <WebSocketContext.Provider value={{socketData, clearSocketData}}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketContext;
